/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PracticalExamAttemptStatusDto = {
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Abandoned: 'ABANDONED'
} as const;

export type PracticalExamAttemptStatusDto = typeof PracticalExamAttemptStatusDto[keyof typeof PracticalExamAttemptStatusDto];



